module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-progress"
  }, [_c('progress-bar', {
    attrs: {
      "percentage": _vm.value,
      "isMini": true
    }
  }), _c('span', {
    staticClass: "progress-percentage"
  }, [_vm._v(_vm._s(_vm.value.toFixed(0)) + "%")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c02ca96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueProgress.vue
// module id = 1829
// module chunks = 0